import { useEffect } from 'react'

const TeamSection = () => {
  const teamImages = [
    '/img/about-us/YES---Agnes-Amelia.png',
    '/img/about-us/YES---Aldo.png',
    '/img/about-us/YES---Arban-Naufal-Hafid.png',
    '/img/about-us/YES---Dio.png',
    '/img/about-us/YES---Eric.png',
    '/img/about-us/YES---Erica.png',
  ]

  const teamImages2 = [
    '/img/about-us/YES---Mirza.png',
    '/img/about-us/YES---Fenny.png',
    '/img/about-us/YES---Ferdian.png',
    '/img/about-us/YES---gabriel.png',
    '/img/about-us/YES---Ramos.png',
  ]

  const teamImages3 = [
    '/img/about-us/YES---Rizki-Nugroho.png',
    '/img/about-us/YES---Satyo.png',
    '/img/about-us/YES---Sekar.png',
    '/img/about-us/YES---Nisa.png',
    '/img/about-us/YES---Nnbela.png',
    '/img/about-us/YES---Shelda.png',
  ]

  useEffect(() => {
    // Initialize seamless scroll animation
    const initSeamlessScroll = (
      wrapperSelector: string,
      direction: 'left' | 'right'
    ) => {
      const wrapper = document.querySelector(wrapperSelector) as HTMLElement
      if (!wrapper) return

      const slides = wrapper.querySelectorAll('.image-slider')
      if (slides.length === 0) return

      // Create container for animation
      const container = document.createElement('div')
      container.style.display = 'inline-flex'
      container.style.transition = 'none'

      // Clone slides 3 times for seamless loop
      for (let i = 0; i < 3; i++) {
        slides.forEach((slide) => {
          container.appendChild(slide.cloneNode(true))
        })
      }

      // Replace wrapper content
      wrapper.innerHTML = ''
      wrapper.appendChild(container)

      // Animation variables
      let position = 0
      const slideWidth = window.innerWidth < 768 ? 180 : 260 // Responsive width
      const totalSlides = slides.length
      const resetPoint = slideWidth * totalSlides
      const speed = 0.3

      // Set initial position
      if (direction === 'right') {
        position = -resetPoint
        container.style.transform = `translateX(${position}px)`
      }

      let isPaused = false

      const animate = () => {
        if (!isPaused) {
          if (direction === 'left') {
            position -= speed
            if (position <= -resetPoint) {
              position = 0
            }
          } else {
            position += speed
            if (position >= 0) {
              position = -resetPoint
            }
          }
          container.style.transform = `translateX(${position}px)`
        }
        requestAnimationFrame(animate)
      }

      animate()

      // Pause on hover
      wrapper.addEventListener('mouseenter', () => {
        isPaused = true
      })
      wrapper.addEventListener('mouseleave', () => {
        isPaused = false
      })
    }

    // Initialize all scrollers with delay
    setTimeout(() => {
      initSeamlessScroll('.scroll-wrapper-1', 'left')
      initSeamlessScroll('.scroll-wrapper-2', 'right')
      initSeamlessScroll('.scroll-wrapper-3', 'left')
    }, 200)
  }, [])

  return (
    <section className="flex flex-col items-center justify-center bg-[#f7f8ff] py-12 md:py-16">
      {/* Container with responsive padding */}
      <div className="mx-auto w-full max-w-[1280px] px-4 md:px-6">
        {/* Section Title */}
        <div className="mb-8 text-center md:mb-10">
          <h2 className="mb-4 font-['Poppins'] text-xl font-bold md:mb-6 md:text-2xl lg:text-3xl">
            <span className="text-[#d91f2e]">Tim</span>
            <span className="text-[#475467]"> Kami</span>
          </h2>

          <div className="mx-auto max-w-[923px] px-4 text-center md:px-0">
            <p className="font-['Poppins'] text-sm font-normal leading-5 md:text-base md:leading-6 lg:text-lg">
              <span className="font-bold text-[#475467]">Di balik </span>
              <span className="font-bold text-[#d91f2e]">YES.co.id</span>
              <span className="font-bold text-[#475467]">
                {' '}
                ada tim yang siap mendampingi kamu hingga siap kerja di Jepang.
              </span>
            </p>

            <br />

            <p className="text-sm font-normal leading-5 text-[#475467] md:text-base md:leading-6 lg:text-lg">
              Tim kami terdiri dari para praktisi berpengalaman di bidang
              edukasi dan teknologi. Mulai dari pengajar bahasa Jepang
              bersertifikasi, career advisor, hingga tim support yang punya satu
              misi:
            </p>

            <br />

            <p className="text-sm font-bold leading-5 text-[#475467] md:text-base md:leading-6 lg:text-lg">
              Membuka jalan bagi talenta Indonesia untuk berkembang dan
              berkarier di Jepang.
            </p>

            <br />

            <p className="text-sm font-normal leading-5 text-[#475467] md:text-base md:leading-6 lg:text-lg">
              Setiap hari, kami bekerja untuk mengubah tantangan itu menjadi
              peluang nyata agar kamu bisa melangkah lebih jauh.
            </p>
          </div>
        </div>
      </div>

      {/* Team Photos Scrolling Section - Full width with no padding */}
      <div className="w-full overflow-hidden">
        {/* First Row - Left Scroll */}
        <div className="scroll-wrapper-1 mb-3 flex h-[120px] items-center overflow-hidden whitespace-nowrap md:mb-4 md:h-[200px]">
          {teamImages.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Team member ${index + 1}`}
              className="image-slider inline-block min-h-[120px] min-w-[150px] object-contain pr-2 md:min-h-[200px] md:min-w-[250px]"
              loading="lazy"
            />
          ))}
        </div>

        {/* Second Row - Right Scroll */}
        <div className="scroll-wrapper-2 mb-3 flex h-[120px] items-center overflow-hidden whitespace-nowrap md:mb-4 md:h-[200px]">
          {teamImages2.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Team member ${index + 1}`}
              className="image-slider inline-block min-h-[120px] min-w-[150px] object-contain pr-2 md:min-h-[200px] md:min-w-[250px]"
              loading="lazy"
            />
          ))}
        </div>

        {/* Third Row - Left Scroll */}
        <div className="scroll-wrapper-3 flex h-[120px] items-center overflow-hidden whitespace-nowrap md:h-[200px]">
          {teamImages3.map((image, index) => (
            <img
              key={index}
              src={image}
              alt={`Team member ${index + 1}`}
              className="image-slider inline-block min-h-[120px] min-w-[150px] object-contain pr-2 md:min-h-[200px] md:min-w-[250px]"
              loading="lazy"
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default TeamSection
